import React from "react";
import Modal from "react-modal";

Modal.setAppElement("#root");

const ModalHalloween = ({ show, toggleModel, children, modalClass }) => {
    const overlyObject = { backgroundColor: "#00000096", zIndex: "9" };
    return (
        <Modal
            className={` ${modalClass}`}
            isOpen={show}
            centered
            contentLabel="onRequestClose Example"
            onRequestClose={toggleModel}
            shouldCloseOnOverlayClick={true}
            style={{ overlay: overlyObject }}
        >
            {children}
        </Modal>
    );
};

export default ModalHalloween;
